export default __webpack_public_path__ + "static/media/b2.b10078f3.JPG";